import { toLogConfig } from './logging.ts';
import { ServerDelegate } from './server.ts';
import { toServerConfig } from './config.ts';
import {
    Gateway,
    GatewayConfig,
    LogInfo,
    LogLevel
} from '../../../types/gateway-ent';
import { configure } from '@interopio/gateway/logging/core';

export function create(config: GatewayConfig): Gateway {
    return new ServerDelegate(toServerConfig(config));
}

export function configure_logging(config?: { level: LogLevel, appender?: (info: LogInfo) => void, disabled_action_groups?: string[] }) {
    configure(toLogConfig(config));
}
